export default __webpack_public_path__ + "static/media/ADIZ_01_mos_MPUR.4dc63326.wav";